import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class TimeoutFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.Timeout;
    }

    getRawFragment(play, serializationContext, timeOut) {
        const { homeTeamId } = serializationContext.gameContext;
        const { team } = timeOut;

        const values = [team.id === homeTeamId ? "H" : "V"];

        return `TOUT:${values.join()}`;
    }
}
